import {compile, parse} from 'path-to-regexp';

import {getRoute, RouteName, RouteParams} from './table';

type Params = Record<string, string | number | null | undefined>;

const compilers = new Map<string, ReturnType<typeof compile>>();
const patternKeys = new Map<string, string[]>();

function toPath(pattern: string) {
	let compiler = compilers.get(pattern);
	if (!compiler) {
		compiler = compile(pattern, {encode: encodeURIComponent});
		compilers.set(pattern, compiler);
	}
	return compiler;
}

/** имена параметров, которые паттерн подставляет в сам адрес */
function keysOf(pattern: string): string[] {
	let keys = patternKeys.get(pattern);
	if (!keys) {
		keys = parse(pattern)
			.filter((token): token is Exclude<typeof token, string> => typeof token !== 'string')
			.map((token) => String(token.name));
		patternKeys.set(pattern, keys);
	}
	return keys;
}

/** выбрасывает пустые значения — их незачем подставлять ни в путь, ни в query */
function usefulParams(params?: Params): Record<string, string> {
	const result: Record<string, string> = {};
	for (const key in params) {
		const value = params[key];
		if (value !== undefined && value !== null && value !== '') result[key] = String(value);
	}
	return result;
}

function toQueryString(params: Record<string, string>): string {
	const search = new URLSearchParams(params).toString();
	return search ? `?${search}` : '';
}

/**
 * Человекочитаемый адрес маршрута: `buildUrl('class', {id: 'bard'})` → `/classes/bard`.
 * Параметры, которых нет в паттерне, уезжают в query-строку.
 */
export function buildUrl<K extends RouteName>(name: K, params?: RouteParams<K>): string {
	const route = getRoute(name);
	const values = usefulParams(params as Params);
	const inPath = keysOf(route.pattern);

	const rest: Record<string, string> = {};
	for (const key in values) {
		if (!inPath.includes(key)) rest[key] = values[key];
	}

	return (toPath(route.pattern)(values) || '/') + toQueryString(rest);
}

